if (document.body.classList.contains("page-aboutus-disaster-0")) {
    const morebtn = document.querySelector(".Txtbtn.normal.plus")

    morebtn.addEventListener("click", () => {
        const disabledYears = document.querySelectorAll(".posts__yearsYear.is-disabled")

        for (let n = 0; n < 5; n++) {
            if (disabledYears[n]) {
                disabledYears[n].classList.remove("is-disabled")
            } else {
                morebtn.classList.add("is-disabled")
                break
            }
        }
    })
}